import React from 'react';

const SinglePicture = ({ alt, src }) => (
  <img className="single-picture" alt={alt} src={src} />
);

export default SinglePicture;
